import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@material-ui/core';

import useGetVehicle from '../hooks/useGetVehicle';
import CollapsibleGroup from '../ui/CollapsibleGroup';

const VehicleSpecsTable = ({ className, type }) => {
  const { t } = useTranslation('details');
  const { vehicle } = useGetVehicle();

  const items = vehicle[type].map((item) => t('Amenity', { context: item })).filter(Boolean);

  if (items.length === 0) return null;

  return (
    <CollapsibleGroup className={className} title={t('Vehicle Specs', { context: type })}>
      <div className="flex flex-wrap text-sm px-2 lg:px-0">
        {items.map((spec, index) => (
          <p key={index} className="w-1/2 md:w-1/3 px-1 pb-4">
            <div className="flex">
              <Icon className="text-base mr-2">check</Icon>
              {spec}
            </div>
          </p>
        ))}
      </div>
    </CollapsibleGroup>
  );
};

VehicleSpecsTable.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['confort', 'equipment', 'exterior', 'security', 'stereo']).isRequired,
};

VehicleSpecsTable.defaultProps = {
  className: '',
};

export default VehicleSpecsTable;
